import { Trans } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import type { FC } from 'react'
import styled from 'styled-components'

import { PhotoModeHeader } from './PhotoModeHeader'
import { PhotoModeSubjectSection } from './PhotoModeSubjectSection'

const Panel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-shrink: 0;
  max-height: 45vh;
  overflow-y: auto;
  padding: 0.75rem 1rem max(0.75rem, env(safe-area-inset-bottom));
  border-top: 0.0625rem solid var(--border);
  background-color: var(--card);
`

export const PhotoModePanel: FC<{
  siteId: string
  subjectUid: string | undefined
  onExit: () => void
}> = ({ siteId, subjectUid, onExit }) => (
  <Panel>
    <PhotoModeHeader onExit={onExit} />
    {subjectUid ? (
      <PhotoModeSubjectSection
        key={subjectUid}
        siteId={siteId}
        subjectUid={subjectUid}
      />
    ) : (
      <Text variant='caption' color='muted'>
        <Trans>Tap a highlighted subject to add a photo.</Trans>
      </Text>
    )}
  </Panel>
)
